import { useTranslation } from 'react-i18next';
import { formatOrderTotal, getOrderSummaryTotals } from '~/utils';
import type { OrderSummaryItem } from '~/utils';
import type { OrderStatus } from '~/graphql/graphql';

export function SellerOrderSummaryCard({
  items,
  status,
  currency: orderCurrency,
  incoTerm,
}: {
  items: OrderSummaryItem[];
  status: OrderStatus;
  currency?: string | null;
  incoTerm?: string | null;
}) {
  const { t } = useTranslation('order');

  const { listedTotal, suggestedTotal, currency, shouldShowSuggestedTotal } =
    getOrderSummaryTotals(items, status, orderCurrency, incoTerm);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <h2 className="text-neut-prim font-semibold mb-4">
        {t('order.order_summary')}
      </h2>
      <div className="space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t('order.subtotal')}</span>
          <span className="text-neut-prim font-medium">
            {formatOrderTotal(listedTotal, t('order.not_available'), currency)}
          </span>
        </div>
        <div className="border-t pt-3 flex justify-between">
          <span className="text-neut-prim font-semibold">
            {t('order.total_amount')}
          </span>
          <span className="text-xl text-prim font-semibold">
            {formatOrderTotal(listedTotal, t('order.not_available'), currency)}
          </span>
        </div>
        {shouldShowSuggestedTotal && (
          <div className="flex justify-between">
            <span className="text-neut-prim font-semibold">
              {t('order.suggested_total')}
            </span>
            <span className="text-xl text-warning-700 font-semibold">
              {formatOrderTotal(
                suggestedTotal,
                t('order.not_available'),
                currency
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
